function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Ebene_2",
  "data-name": "Ebene 2",
  transform: "translate(-5.062 -5.026)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Inhalt",
  transform: "translate(5.062 5.026)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pfad_27",
  "data-name": "Pfad 27",
  d: "M0,0,11.9-.014l-.007,5.951-11.9.014Z",
  transform: "translate(1.391 8.426) rotate(-45)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Pfad_26",
  "data-name": "Pfad 26",
  d: "M5.762,11.474l2.8,2.8-3.5.7Z",
  transform: "translate(-5.062 -0.873)",
  fill: "#fff"
})));

var SvgEdit = function SvgEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14.015,
    height: 14.101,
    viewBox: "0 0 14.015 14.101",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/edit.98f1f58a.svg";
export { ForwardRef as ReactComponent };